import * as config from "Config";
import * as constants from "./constants";


export function clearStore(newObject) {
  return {
    type: constants.ORDER_STATUS_LIST_CLEAR_STORE
  };
}

export function initListData(params) {
  let url = config.apiUrl + "/api/OrderStatus";
  if (params.companyId) {
    url += "/Company/" + params.companyId + "/Summury";
  }
  if (params.companyGroupId) {
    url += "/CompanyGroup/" + params.companyGroupId + "/Summury";
  }

  return {
    remote: {
      method: "get",
      url
    },
    actions: [
      constants.ORDER_STATUS_LIST_SUMMURY_LOAD_START,
      constants.ORDER_STATUS_LIST_SUMMURY_LOAD_SUCCESS,
      constants.ORDER_STATUS_LIST_SUMMURY_LOAD_FAIL,
    ]
  };
}

export function deleteOrderStatus(params) {
  let url = config.apiUrl + "/api/OrderStatus/" + params.id;
  if (params.companyId) {
    url += "/Company/" + params.companyId;
  }
  if (params.companyGroupId) {
    url += "/CompanyGroup/" + params.companyGroupId;
  }

  return {
    remote: {
      method: "delete",
      url
    },
    actions: [
      constants.ORDER_STATUS_LIST_REMOVE_START,
      constants.ORDER_STATUS_LIST_REMOVE_SUCCESS,
      constants.ORDER_STATUS_LIST_REMOVE_FAIL,
    ]
  };
}
